import React from "react"

// TODO: add about
export function HomePage(props) {
  return <div>HomePage</div>
}
